import is from '../../../comparator/is';

import { IStorageEngine } from './storage-engine';

export class CookieStorage implements IStorageEngine {
  constructor(private appId: string) {
    // TODO global
    this.Global = typeof window !== 'undefined' ? window : window;
  }

  private Global;
  private trim: any;

  set(key: string, value: any, expire?: Date) {
    if (is.nullOrUndefined(key)) {
      return;
    }
    const appKey = `${this.appId}-${key}`;
    this.Global.document.cookie = `${escape(appKey)}=${escape(value)}; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/`;
    this.trim = this.make_trim();
  }

  get(key: string): string | null {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return null;
    }

    const appKey = `${this.appId}-${key}`;
    const regexpStr = `(?:^|.*;\\s*)${escape(appKey).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*`;
    return unescape(this.Global.document.cookie.replace(new RegExp(regexpStr), '$1'));
  }

  remove(key: string) {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return;
    }
    const appKey = `${this.appId}-${key}`;
    this.Global.document.cookie = `${escape(appKey)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  make_trim() {
    if (String.prototype.trim) {
      return function trim(str: string) {
        return String.prototype.trim.call(str);
      };
    } else {
      return function trim(str: string) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
      };
    }
  }

  each(callback: (arg_1: any, arg_2: any) => void) {
    const cookies = this.Global.document.cookie.split(/; ?/g);
    for (let i = cookies.length - 1; i >= 0; i--) {
      if (!this.trim(cookies[i])) {
        continue;
      }
      const kvp = cookies[i].split('=');
      const key = unescape(kvp[0]);
      const val = unescape(kvp[1]);
      callback(val, key);
    }
  }

  clearAll() {
    this.each((_, key) => {
      this.remove(key);
    });
  }

  hasKey(key: string): boolean {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return false;
    }

    const appKey = `${this.appId}-${key}`;
    return new RegExp(`(?:^|;\\s*)${escape(appKey).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=`).test(
      this.Global.document.cookie,
    );
  }

  isExpried<T>(key: string): boolean {
    /*** 不存在指定key的缓存 ***/
    if (is.nullOrUndefined(key)) {
      return true;
    }
    const appKey = `${this.appId}-${key}`;
    const expireKey = `${appKey}-expire`;

    const cookieList = document.cookie.split(';');

    // cookie项
    const contentItem = cookieList.find((item) => {
      return item.indexOf(appKey) == 0;
    });

    // 过期cookie
    const expireItem = cookieList.find((item) => {
      return item.indexOf(expireKey) == 0;
    });

    /*** 有指定key的cookie,但未设置过期时间,视为不会过期返回true ***/
    if (!is.nullOrUndefined(contentItem) && is.nullOrUndefined(expireItem)) {
      return false;
    }
    // 过期时间
    const expireDateString = expireItem?.split('=')[1];
    if (is.nullOrUndefined(expireDateString)) {
      return false;
    }
    const expireDate = new Date(expireDateString);
    const currentDate = new Date();
    const expireTime = expireDate.getTime();
    const currentTime = currentDate.getTime();

    return currentTime > expireTime;
  }
}
